import Http from "../../service/api";
import { judgeIsSplice } from "../../common/utils";

// -----------------------------  首页  -------------------------
/**
 * 获取知识库列表 get query
 * @param {*} params 
 */
export async function getKnowledgeList(params: any) {
  return Http.get(`/api/v1/exam/knowledge/userList${judgeIsSplice()}`, params);
}
/**
 * 获取知识库分类列表 get query
 * @param {*} params 
 */
export async function getClassifyList(params: any) {
  return Http.get(`/api/v1/exam/classifyList${judgeIsSplice()}`, params);
}
/**
 * 获取加签的下载链接 get query
 * @param {*} params 
 */
export async function getKnowledgeListSignUrl(params: any) {
  return Http.get(`/api/v1/exam/knowledge/getSignUrl${judgeIsSplice()}`, params);
}
